import { CardContent } from '@/components/Card'
import { Button } from '@/components/Button'

export interface DraftInReviewProgressionActionsProps {
  onShowApproveDraftDialog: () => void
  onShowRejectDraftDialog: () => void
}

export function DraftInReviewProgressionActions({
  onShowApproveDraftDialog,
  onShowRejectDraftDialog,
}: DraftInReviewProgressionActionsProps) {
  return (
    <>
      <CardContent compactBottomPadding>
        <Button
          label="Approve Draft"
          variant="primary"
          size="wide-slim"
          onPress={onShowApproveDraftDialog}
          testId="job-progression-show-approve-draft-dialog"
        />
      </CardContent>
      <CardContent>
        <Button
          label="Reject Draft"
          variant="secondary"
          size="wide-slim"
          onPress={onShowRejectDraftDialog}
          testId="job-progression-show-reject-draft-dialog"
        />
      </CardContent>
    </>
  )
}
